export default __webpack_public_path__ + "static/media/Spiderman_04.71d97f15.png";